import type { FormInputItem } from '@/components/InvoiceReportDetailDrawer/ApplicationContent/types';
import { Caption } from '@moneyforward/ap-frontend-components';
import { FC, memo } from 'react';

type DefaultFieldViewProps = {
  item: FormInputItem;
  mismatchCaption?: string;
};

export const DefaultFieldView: FC<DefaultFieldViewProps> = memo(
  ({ item, mismatchCaption }) => {
    return (
      <>
        <div>{item?.input_values?.[0]?.label ?? ''}</div>
        {mismatchCaption && <Caption type='alert'>{mismatchCaption}</Caption>}
      </>
    );
  }
);

DefaultFieldView.displayName = 'DefaultFieldView';
